import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';

export const useRelatedAccountsFetch = deal => {
  const {
    data: { account = [] } = {},
    loading,
    refetch,
  } = useQuery(GetOrganizationsListDocument, {
    variables: { where: { exchange_account_network_id: { _in: deal?.account_id ? [deal.account_id] : undefined } } },
  });

  const mapById = useMemo(
    () =>
      account.reduce((acc, account) => {
        acc[account.exchange_account_network?.uid] = { id: account.exchange_account_network?.uid, name: account.name };
        return acc;
      }, {}),
    [account]
  );

  return {
    loading,
    mapById,
    refetch,
  };
};
